import ApplicationController from "./application_controller";
import Tribute from "tributejs";
import Trix from "trix";

export default class extends ApplicationController {
  static targets = [ "field" ]

  connect() {
    this.editor = this.fieldTarget.editor
    this.initializeTribute()
  }

  disconnect() {
    this.tribute.detach(this.fieldTarget)
  }

  initializeTribute() {
    this.tribute = new Tribute({
      allowSpaces: true,
      lookup: function(item) {
        // Zeige nur E-Mail wenn kein Name vorhanden ist
        if (!item.firstname || !item.lastname || item.firstname === 'null' || item.lastname === 'null') {
          return item.email
        }
        return item.firstname + ' ' + item.lastname + ' (' + item.email + ')'
      },
      values: this.fetchUsers,
    })
    this.tribute.attach(this.fieldTarget)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
    this.fieldTarget.addEventListener("tribute-replaced", this.replaced)
  }

  fetchUsers(text, callback) {
    fetch(`/backend/mentions.json?query=${text}`)
        .then(response => response.json())
        .then(users => callback(users))
        .catch(error => callback([]))
  }

  replaced(e) {
    let mention = e.detail.item.original
    let attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.email
    })
    this.editor.insertAttachment(attachment)
    this.editor.insertString(" ")
  }

  _pasteHtml(html, startPos, endPos) {
    let position = this.editor.getPosition()
    this.editor.setSelectedRange([position - endPos, position])
    this.editor.deleteInDirection("backward")
  }
}